import React from "react";
import { useSelector } from "react-redux";
import { selectSpaceSideBar } from "slices/spaceMediaSlice";
import SpaceSideBar from "./SpaceSideBar/SpaceSideBar";

const SpaceSideContainer = () => {
  const spaceSideBar = useSelector(selectSpaceSideBar);

  if (!spaceSideBar) return null;
  return <SpaceSideBar spaceSideBar={spaceSideBar} />;
};

export default SpaceSideContainer;
